import i18n from "../config/i18n";

export const validate = (data, type) => {
  const errors = {};

  if (!data.email) {
    errors.email = i18n.t("authErrors.emailRequired");
  } else if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(data.email).toLowerCase())) {
    errors.email = i18n.t("authErrors.emailInvalid");
  } else {
    delete errors.email;
  }

  if (!data.password) {
    errors.password = i18n.t("authErrors.passwordRequired");
  } else if (!(data.password.length >= 6)) {
    errors.password = i18n.t("authErrors.passwordMinLength");
  } else {
    delete errors.password;
  }

  if (type === "signUp") {
    if (!data.name.trim()) {
      errors.name = i18n.t("authErrors.nameRequired");
    } else {
      delete errors.name;
    }
    if (!data.confirmPassword) {
      errors.confirmPassword = i18n.t("authErrors.confirmPassword");
    } else if (!(data.confirmPassword === data.password)) {
      errors.confirmPassword = i18n.t("authErrors.passwordNoMatch");
    } else {
      delete errors.confirmPassword;
    }

    if (data.IsAccepted) {
      delete errors.IsAccepted;
    } else {
      errors.IsAccepted = i18n.t("authErrors.acceptTerms");
    }
  }

  return errors;
};
